(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mg-cable-product"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mg-cable-product'))customElements.define('mg-cable-product',class extends HTMLElement{
 connectedCallback(){const bar=this.querySelector('.mca-sticky');this.observer=new IntersectionObserver(([e])=>{bar.hidden=e.isIntersecting||e.boundingClientRect.top>0;});this.observer.observe(this.querySelector('.mca-purchase'));}
 disconnectedCallback(){this.observer?.disconnect();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mg-callus-product"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mg-callus-product'))customElements.define('mg-callus-product',class extends HTMLElement{
 connectedCallback(){const bar=this.querySelector('.mcc-sticky');this.observer=new IntersectionObserver(([e])=>{bar.hidden=e.isIntersecting||e.boundingClientRect.top>0;});this.observer.observe(this.querySelector('.mcc-purchase'));}
 disconnectedCallback(){this.observer?.disconnect();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mg-chalk-product"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mg-chalk-product'))customElements.define('mg-chalk-product',class extends HTMLElement{
 connectedCallback(){const bar=this.querySelector('.mlc-sticky');this.observer=new IntersectionObserver(([e])=>{bar.hidden=e.isIntersecting||e.boundingClientRect.top>0;});this.observer.observe(this.querySelector('.mlc-purchase'));}
 disconnectedCallback(){this.observer?.disconnect();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mg-hang-program"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mg-hang-program')) {
    customElements.define('mg-hang-program', class extends HTMLElement {
      connectedCallback() {
        const purchase = this.querySelector('.mhp-purchase');
        const sticky = this.querySelector('.mhp-sticky');
        this.observer = new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, {threshold: 0});
        this.observer.observe(purchase);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mg-product-addons"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mg-product-addons'))customElements.define('mg-product-addons',class extends HTMLElement{
 connectedCallback(){
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{if(this.isConnected)this.setup();},{once:true});else this.setup();
 }
 setup(){
  this.abort?.abort();
  this.abort=new AbortController();const options={signal:this.abort.signal};
  this.hidden=!this.querySelector('input');
  this.addEventListener('change',()=>this.sync(),options);
  document.addEventListener('formdata',event=>{
   if(event.target.getAttribute('id')!==this.dataset.form)return;
   const selected=this.querySelector('input:checked');if(!selected)return;
   const data=event.formData;const id=data.get('id');if(!id)return;
   data.set('items[0][id]',id);data.set('items[0][quantity]',data.get('quantity')||'1');
   for(const [key,value] of [...data.entries()]){
    if(key.startsWith('properties[')){data.set('items[0][properties]'+key.slice(10),value);data.delete(key);}
   }
   if(data.has('selling_plan')){data.set('items[0][selling_plan]',data.get('selling_plan'));data.delete('selling_plan');}
   data.delete('id');data.delete('quantity');
   data.set('items[1][id]',selected.value);data.set('items[1][quantity]','1');
  },options);
  document.addEventListener('variant:add',event=>{
   if(event.target.getAttribute('id')!==this.dataset.form)return;
   const input=this.querySelector('input');const added=input?.checked;if(input)input.checked=false;this.sync();if(added)this.hidden=true;
  },options);
 }
 sync(){const status=this.querySelector('.mg-addons-selected');if(status)status.hidden=!this.querySelector('input:checked');}
 disconnectedCallback(){this.abort?.abort();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mg-rope-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mg-rope-page')) {
    customElements.define('mg-rope-page', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const form = document.getElementById(this.dataset.form);
        if (!form) return;
        const variants = JSON.parse(this.querySelector('[data-construction-variants]').textContent);
        let updateSticky = () => {};
        const sync = () => {
          const selected = this.querySelector('input[name="option1"]:checked');
          if (!selected) return;
          const variant = variants.find(item => String(item.id) === String(form.elements.id.value));
          const build = variant?.construction || this.querySelector('input[name="option2"]:checked')?.value || 'Standard';
          const isBundle = selected.dataset.variantId === '43421749641406';
          this.querySelectorAll('[data-selection]').forEach(panel => { panel.hidden = panel.dataset.selection !== selected.dataset.variantId; });
          this.querySelector('[data-sticky-name]').textContent = selected.dataset.friendlyName + (this.querySelector('.mg-construction') ? ' · ' + build : '');
          this.querySelector('[data-pack-note]').textContent = this.querySelector(isBundle ? '[data-bundle-label]' : '[data-pair-label]').textContent;
          this.querySelectorAll('input[name="option1"]').forEach(radio => {
            const match = variants.find(item => item.grip === radio.value && item.construction === build);
            const price = radio.closest('label').querySelector('[data-grip-price]');
            const saving = radio.closest('label').querySelector('[data-bundle-saving]');
            if (match && saving) saving.textContent = match.saving;
            if (match && price) price.textContent = match.price + (match.available ? '' : ' · ' + this.querySelector('[data-sold-out-label]').textContent);
          });
          const pro = variants.find(item => item.grip === selected.value && item.construction === 'Pro');
          const premium = this.querySelector('[data-pro-premium]');
          if (premium && pro) premium.textContent = '+' + pro.premium;
          const note = this.querySelector('[data-construction-note]');
          if (note) note.textContent = this.querySelector(build === 'Pro' ? (isBundle ? '[data-pro-bundle-note]' : '[data-pro-note]') : '[data-standard-note]').textContent;
          updateSticky();
        };
        form.addEventListener('variant:change', () => { sync(); this.dispatchEvent(new CustomEvent('mg:interaction', {bubbles:true,detail:{type:'variant_selected',productId:this.dataset.product,variantId:form.elements.id.value}})); }, {signal});
        this.addEventListener('click', event => {
          if (event.target.closest('[data-sticky-add]')) {
            event.preventDefault();
            form.requestSubmit(primaryButton);
            return;
          }
          const choice = event.target.closest('[data-select-variant]');
          if (choice) {
            const radio = this.querySelector(`input[data-variant-id="${choice.dataset.selectVariant}"]`);
            if (!radio) return;
            event.preventDefault();
            radio.click();
            this.querySelector('#mg-choose').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
            radio.focus({preventScroll:true});
          }
          const shipping = event.target.closest('a[href="#mg-shipping"]');
          if (shipping) this.querySelector('#mg-shipping').open = true;
          if (event.target.closest('a[href="#mg-warranty"]')) this.querySelector('#mg-warranty').open = true;
        }, {signal});
        const sticky = this.querySelector('.mg-sticky');
        const primaryButton = this.querySelector('.mg-main-buy button[type="submit"]');
        const title = this.querySelector('.mg-title');
        let frame = 0;
        updateSticky = () => {
          if (matchMedia('(min-width: 700px)').matches) {
            sticky.hidden = true;
            return;
          }
          const buttonRect = primaryButton.getBoundingClientRect();
          const buttonVisible = buttonRect.top < window.innerHeight && buttonRect.bottom > 100;
          sticky.hidden = buttonVisible || title.getBoundingClientRect().bottom > 100;
        };
        const scheduleSticky = () => {
          if (frame) return;
          frame = requestAnimationFrame(() => { frame = 0; updateSticky(); });
        };
        window.addEventListener('scroll', scheduleSticky, {passive:true,signal});
        window.addEventListener('resize', scheduleSticky, {passive:true,signal});
        this.observer = new IntersectionObserver(scheduleSticky);
        this.observer.observe(primaryButton);
        this.observer.observe(title);
        sync();
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mg-slings-product"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mg-slings-product'))customElements.define('mg-slings-product',class extends HTMLElement{
 connectedCallback(){const bar=this.querySelector('.mgs-sticky');this.observer=new IntersectionObserver(([e])=>{bar.hidden=e.isIntersecting||e.boundingClientRect.top>0;});this.observer.observe(this.querySelector('.mgs-purchase'));}
 disconnectedCallback(){this.observer?.disconnect();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mg-thick-product"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mg-thick-product'))customElements.define('mg-thick-product',class extends HTMLElement{
 connectedCallback(){const bar=this.querySelector('.mtp-sticky');this.observer=new IntersectionObserver(([e])=>{bar.hidden=e.isIntersecting||e.boundingClientRect.top>0;});this.observer.observe(this.querySelector('.mtp-purchase'));}
 disconnectedCallback(){this.observer?.disconnect();}
});
  } catch(e) { console.error(e); }
})();

})();
